import { PessoaUnidade } from "./pessoa-unidade";
import { SegurancaPessoa } from "./seguranca-pessoa";
import { Endereco } from "./endereco";
import { GrupoPessoa } from "./grupo-pessoa.model";

export class Pessoa {

  id: number;
  nome: string;
  sobrenome: string;
  nomeCompleto: string;
  dataNascimento: any;
  estadoCivil: string;
  sociedade: string;
  cpf: string;
  cnpj: string;
  rg: string;
  inscricaoEstadual: string;
  documentos: any[];
  pessoaUnidades: Array<PessoaUnidade> = new Array<PessoaUnidade>();
  pessoaUnidadesAtivas: Array<PessoaUnidade> = new Array<PessoaUnidade>();
  grupoPessoaDTO: Array<GrupoPessoa> = new Array<GrupoPessoa>();
  documentosDTO: any;
  data: any;
  segurancaPessoa: SegurancaPessoa;
  enderecos: Array<Endereco> = new Array<Endereco>();
  habilitarCampoCriarUsuario: boolean;
  Endereco: Endereco;
  grupo: string;
  grupos: any[];
  primeiroAcesso: boolean;
  integracaoId: string;
  configNotificacaoEvento: any;
  unidadesVinculadas: string;
  email: string;
  telefone?: string;
}
